import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { withUser } from "@/helpers/user";
import { Layout, Menu } from "antd";
import { Outlet } from "@/helpers/router";
const { Sider, Content } = Layout;
import Toolbar from "./toolbar";
import AppliedFilters from "@/components/common/applied-filters";
import { areRouteQueriesEqual, getNormalizedRouteQuery } from "@/helpers/search";
import { keepOnlyQueryStrings, qs2label, omitInvalidSort } from "./field-defs";

const UPCSearch = ({ location, router, user }) => {
  useEffect(() => {
    const routeQuery = keepOnlyQueryStrings(location.query);
    const nextRouteQuery = getNormalizedRouteQuery(routeQuery, omitInvalidSort);
    if (areRouteQueriesEqual(routeQuery, nextRouteQuery)) return;
    router.replace({ pathname: location.pathname, query: nextRouteQuery });
  }, [location.search]);

  const filter = omitInvalidSort(keepOnlyQueryStrings(location.query));
  const accessLevel = user?.accessLevel?.upc;
  const exportLevel = user?.accessLevel?.caseExport;

  const onMenuClick = item => {
    router.push({
      pathname: item.key,
      query: keepOnlyQueryStrings(location.query)
    });
  };

  const onQueryChange = (nextQuery, { replace = false } = {}) => {
    const navigate = replace ? router.replace : router.push;
    navigate({
      pathname: location.pathname,
      query: keepOnlyQueryStrings(nextQuery)
    });
  };

  return (
    <Layout style={{ width: "100%", padding: 30 }}>
      <Sider width={260} breakpoint="lg" collapsedWidth="0" style={{ background: "transparent", marginRight: 16 }}>
        <Toolbar />
      </Sider>
      <Content>
        <AppliedFilters fieldSelector={keepOnlyQueryStrings} fieldMapper={qs => qs2label[qs]} />
        <Menu
          selectedKeys={[location.pathname]}
          onClick={onMenuClick}
          mode="horizontal"
          items={[
            { key: "/upc/search", label: "CASES" },
            { key: "/upc/analytics", label: "ANALYTICS" }
          ]}
        />
        <Outlet context={{ filter, accessLevel, exportLevel, onQueryChange }} />
      </Content>
    </Layout>
  );
};
UPCSearch.propTypes = {
  location: PropTypes.object,
  router: PropTypes.object,
  user: PropTypes.object
};

export default withUser(UPCSearch);
